/**
 * Authoritative web deploy identifier for native WebView freshness checks.
 *
 * Vercel injects `VERCEL_GIT_COMMIT_SHA` at build and runtime; fall back to
 * `VERCEL_DEPLOYMENT_ID` so preview deploys still get a unique id. Local dev
 * uses the stable sentinel `development` so resume checks never reload-loop.
 */
export const WEB_BUILD_ID_DEV = 'development' as const

export function getWebBuildId(): string {
  const sha = process.env.VERCEL_GIT_COMMIT_SHA?.trim()
  if (sha) return sha

  const deploymentId = process.env.VERCEL_DEPLOYMENT_ID?.trim()
  if (deploymentId) return deploymentId

  return WEB_BUILD_ID_DEV
}
